import ConfirmModal from "./ConfirmModal";
import AlertModal from "./AlertModal";

const modalTypes = {
  ConfirmModal,
  AlertModal
};

export default modalTypes;
